import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import bannerImage from '../../images/Logo/Company_Logo_Black.png';
import '../styles/UserEmailVerificationPage.css';
import { verifyUserEmail } from '../services/UserAuthService';

const UserEmailVerificationPage = () => {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const verify = async () => {
      try {
        await verifyUserEmail(uidb64, token);
        setSuccess(true);
      } catch (error) {
        setSuccess(false);
      }
    };

    verify();
  }, [uidb64, token]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  const handleGoToSignUp = () => {
    navigate('/sign-up');
  };

  return (
    <div className="user-email-verification-page">
      <div className="auth-page__structure">
        <div className="auth-page__content">
          {success !== null && (
            <>
              <h1 className="auth_page__cta-title">
                {success ? 'Verification Successful' : 'Verification Failed'}
              </h1>
              <p className="auth-page__cta-subtitle">
                {success
                  ? 'Your account has been successfully verified. You can now start enjoying our website.'
                  : 'The verification link is not valid or has expired. Please try creating your account again.'}
              </p>
              <div className="user-email-verification-page__buttons">
                {success ? (
                  <button className="button" onClick={handleGoToLogin}>Login</button>
                ) : (
                  <button className="button" onClick={handleGoToSignUp}>Create Account</button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserEmailVerificationPage;